import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Tooltip as ReactTooltip } from 'react-tooltip'

class Swatch extends Component {
  getBgStyle () {
    const swatch = this.props.swatch
    const styles = {}

    if (swatch && swatch.colour && swatch.secondary_colour) {
      styles.background = `linear-gradient( -45deg, ${swatch.secondary_colour}, ${swatch.secondary_colour} 49%, white 49%, white 51%, ${swatch.colour} 51% )`
    } else if (swatch && swatch.colour && !swatch.image_path) {
      styles.backgroundColor = swatch.colour
    }

    if (swatch && swatch.image_path) {
      styles.backgroundImage = `url(${swatch.image_path.default})`
    }

    return styles
  }

  render () {
    return (
      <label className={classNames('relative cursor-pointer', this.props.className)}>
        <span className="sr-only">
          {this.props.name}
        </span>

        <input type="radio" className="absolute -left-max" value={this.props.colour} checked={this.props.checked} onChange={this.props.onChange && this.props.onChange} />

        <span className={classNames('w-8 h-8 rounded-1/2 p-0.5 block overflow-hidden border border-grey hover:border-charcoal focus:border-charcoal transition-colors duration-150 ease-in-out', { 'border-charcoal': this.props.checked }, { 'border-transparent': !this.props.checked })} data-tip={this.props.name}>
          <span className="block w-full h-full rounded-1/2" style={this.getBgStyle()}></span>
        </span>

        <ReactTooltip
          effect="solid"
          backgroundColor="#000000"
          className="tooltip"
        />
      </label>
    )
  }
}

Swatch.propTypes = {
  checked: PropTypes.bool.isRequired,
  colour: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  swatch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default Swatch
